import { CONTENTS_CONSTANTS } from '@flows/configs/contents/constants'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import { DEDUCTIBLE_INFO } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe } from '@flows/insurance/schemas'

const contents_deductibles = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('deductible_amount')]:
        BaseSchema_ContentsPremiumBasicNeodigitalDe.shape.deductible_amount,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.deductibles.title',
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('deductible_amount'),
        options: CONTENTS_CONSTANTS.deductibles.map((option) => {
          return {
            label: {
              type: 'nonTranslatableText',
              text: params.clientHelpers.formatter.formatCurrency(option),
            },
            value: Number(option),
          }
        }),
      },
      DEDUCTIBLE_INFO(),
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_glass',
  }) as const satisfies AnyStepConfiguration

export default contents_deductibles
